$(document).ready(function() {

  var buttons = document.getElementsByClassName('button');
  for(var i = 0; i < buttons.length; i++){
    buttons[i].href+=window.location.search;
  }

  //smooth scrolling
  $(".header__menu-item a").on("click", function (event) {
    event.preventDefault();
    var id = $(this).attr('href'),
        top = $(id).offset().top;
    $('body,html').animate({scrollTop: top - 100}, 600);
  });

  //countdown
  $('.banner__timer').countdown('2019/06/27', function(event) {
    var $this = $(this).html(event.strftime(''
        + '<p class="banner__timer-item"><span class="banner__timer-count">%D</span> дней</p> '
        + '<p class="banner__timer-item"><span class="banner__timer-count">%H</span> часов</p> '
        + '<p class="banner__timer-item"><span class="banner__timer-count">%M</span> минут</p> '
        + '<p class="banner__timer-item"><span class="banner__timer-count">%S</span> секунд</p> '));
  });

  //mobile menu
  $('.btn-menu').click(function () {
    $('.header').toggleClass('active')
    $('.btn-menu').toggleClass('active')
    $('.header__menu-item a').click(function () {
      $('.header').removeClass('active')
      $('.btn-menu').removeClass('active')
    })
  })

  //fixed menu
  var menu = $('.banner');
  var menuPosition;

  $(window).on('scroll', function () {
    var menuCoords = menu.offset();
    var windowScroll = $(this).scrollTop();
    if (!menuPosition) {
      menuPosition = menuCoords.top;
    }
    if (windowScroll > 0) {
      $('.header').addClass('scrolled')
    } else {
      menuPosition = false;
      $('.header').removeClass('scrolled')
    }
  });


  //google map
  if($('div').is('.map')) {
    function initMap () {
      var iZoom = 17
      var uluru = {lat: 55.029406, lng: 82.928142};
      if ($(window).width() <= 900) {
        uluru = {lat: 55.029206, lng: 82.926842};
      }
      var mapOptions = {
        zoom: iZoom,
        center: uluru,
        disableDefaultUI: true,
        styles: [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "elementType": "labels",
            "stylers": [
              {
                "color": "#cdcdcd"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "elementType": "labels.text",
            "stylers": [
              {
                "color": "#616161"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#f5f5f5"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#b9b9b9"
              },
              {
                "visibility": "on"
              },
              {
                "weight": 6.5
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "labels.icon",
            "stylers": [
              {
                "color": "#dadada"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "labels.text",
            "stylers": [
              {
                "color": "#dadada"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dadada"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#c9c9c9"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }
        ]
      }
      var map = new google.maps.Map(document.getElementById('map'), mapOptions)
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng({"lat" : 55.029277, "lng" : 82.926286}),
        map: map
      });
    }
    initMap();
  }
  
})